import React from 'react'

function AddressPage() {
  return (
    <div>AddressPage</div>
  )
}

export default AddressPage